module.exports = __webpack_public_path__ + "static/media/zhineng.f80d37c5.jpg";